import { DayReport } from '../models/dayreport';
import { Sort, SortDirection } from '../models/sort';
import { ReportSummaries } from '../models/reportsummaries';

export class PrepareListData {
    static columnNames: any = { month: 'Month', 
        weekNo: 'Week No',
        empName: 'Name', 
        day: 'Day', 
        projNo: 'Project No', 
        projName: 'Project Name', 
        taskNo: 'Task No', 
        taskName: 'Task Name', 
        expType: 'Exp. Type', 
        hours: 'Hours' };

        public static curData:DayReport[] = [];

    static getDisplayWeek(weekNo: string): string {
        return `${weekNo.slice(0, 4)}-${weekNo.slice(4, 6)}`;
    }

    static async reCalculateSubTotals(cleanedData: DayReport[], sortField: string) {
        let tmpData: any[] = [];
        let subTotal = 0;
        tmpData[tmpData.length - 1];
        cleanedData.forEach( (x : any) => {
            if ( tmpData.length === 0 || x[sortField] === tmpData[tmpData.length - 1][sortField] ) {
                subTotal = subTotal + x.hours;
                tmpData.push(x);
            }
            else {
                let subTotRow = new DayReport(null);
                subTotRow.isSubTotalRow = true;
                subTotRow.expType = `${this.columnNames[sortField]} Total: ${tmpData[tmpData.length - 1][sortField]}`; 
                subTotRow.expType = sortField === 'weekNo' 
                    ? 'Total: ' + this.getDisplayWeek(tmpData[tmpData.length - 1][sortField]) 
                    : 'Total: ' + tmpData[tmpData.length - 1][sortField]; 

                subTotRow.hours = subTotal;
                tmpData.push(subTotRow);
                tmpData.push(x);
                subTotal = x.hours;
            }
        });

        // if subTotal > 0 then the final sum row is not added (by design) in the foreach
        if (subTotal > 0) {
            let subTotRow = new DayReport(null);
            subTotRow.isSubTotalRow = true;
            subTotRow.expType = `${this.columnNames[sortField]} Total: ${tmpData[tmpData.length - 1][sortField]}`;
            subTotRow.hours = subTotal;
            tmpData.push(subTotRow);
        }
        return tmpData;
    }

    static async sort(dataSource: DayReport[], sort: Sort, sortField: string): Promise<DayReport[]> {
        if (dataSource.length === 0) return Promise.resolve([]);
        return await this.sortData( dataSource, sort, sortField )
    }

    static removeSubTotals(dataSource: DayReport[]): DayReport[] {
        let tmpData: DayReport[] = [];
        dataSource.forEach( x => {
            if (!x.isSubTotalRow) {
                tmpData.push(x);
            }
        });
        return tmpData;
    }

    static async sortData(dataSource: DayReport[], sort: Sort, sortField: string): Promise<DayReport[]> {
        let cleanedData: DayReport[] = this.removeSubTotals( dataSource );

        if ( sort.direction === "asc" ) {
            sortField = sort.active;
            this.sortDataAsc( cleanedData, sortField );
        } else if ( sort.direction === "desc" ) {
            sortField = sort.active;
            this.sortDataDesc( cleanedData, sortField );
        } else {
            this.sortDataDesc( cleanedData, sortField );
        }
        return this.reCalculateSubTotals( cleanedData, sortField );
    }

    static sortDataDesc(tmpData: DayReport[], sortField: string) {
        tmpData.sort( function (a: any,b: any) { return ( b[sortField] > a[sortField] ) ? 1 : -1; } );
    }

    static sortDataAsc(tmpData: DayReport[], sortField: string) {
        tmpData.sort( function (a: any,b: any) { return ( a[sortField] <= b[sortField] ) ? -1 : 1; } );
    }

    static prepareData(data: DayReport[], summay: ReportSummaries, sortField: string): Promise<DayReport[]> {
        summay.totalHours = 0;
        summay.rowCount = 0;
        data.forEach( x => {
            summay.totalHours = summay.totalHours + x.hours;
            summay.rowCount ++;
        });

        let tmpData: DayReport[] = [];
        data.forEach( x => {
            tmpData.push(new DayReport(x));
        })
        data = tmpData; 

        var sort: Sort = {
            active: sortField,
            direction: 'asc'
        };
        
        return this.sort(tmpData, sort, sort.active);
    }
}